var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie"},[_c('div',{ref:"main",staticStyle:{"float":"left","width":"100%","height":"100px"},attrs:{"id":"main1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }